import React from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainAndProduct() {
  return <>
      {/* SECCIÓN 2: DOLOR */}
      <section className="py-20 px-4 bg-white" data-id="element-66">
        <div className="max-w-3xl mx-auto" data-id="element-67">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep mb-10 text-center leading-tight" data-id="element-68">
            Si sos docente de primaria en Uruguay · esto te va a sonar familiar:
          </h2>

          <div className="space-y-4 mb-12" data-id="element-69">
            {['Domingos perdidos buscando material que nunca está alineado al EBI', 'Fichas armadas a las corridas sin secuencia ni estructura', 'Evaluaciones sin rúbricas · sin los 4 niveles que pide el programa', 'Planificaciones para el director/a hechas la noche anterior', '8 áreas · 36 semanas · y todo sobre tus hombros'].map((pain, i) => <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} key={i} className="flex items-start gap-4 bg-red-50 border border-red-100 p-5 rounded-2xl" data-id="element-70">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-71" />
                <p className="text-brand-text font-medium text-lg" data-id="element-72">{pain}</p>
              </motion.div>)}
          </div>

          <p className="text-2xl md:text-3xl font-display font-bold text-center text-brand-orange" data-id="element-73">
            ¿Cuántos domingos más vas a perder?
          </p>
        </div>
      </section>

      {/* SECCIÓN 3: PRODUCTO */}
      <section className="py-20 px-4 bg-brand-deep text-white text-center relative overflow-hidden" data-id="element-74">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-blue/40 rounded-full blur-[120px] pointer-events-none" data-id="element-75"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-76">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm font-bold mb-8" data-id="element-77">
            <span data-id="element-78">🏆</span> Sistema que tod@s l@s maestr@s de primaria en
            Uruguay eligen!
          </div>

          <div className="text-brand-orange font-bold tracking-widest text-sm mb-4 uppercase" data-id="element-79">
            🌟 Tu Fénix Digital
          </div>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-display font-bold mb-8 text-white drop-shadow-lg" data-id="element-80">
            AULA DE <span className="text-brand-orange" data-id="element-81">ÉXITOS</span>
          </h2>

          <p className="text-xl md:text-2xl font-medium mb-12 max-w-2xl mx-auto text-brand-sky leading-relaxed" data-id="element-82">
            8 tomos por tramo · 550 páginas · 6 bonos incluidos. Todo listo para
            usar desde hoy.
          </p>

          <div className="flex flex-wrap justify-center gap-3" data-id="element-83">
            {['Inicial', '1° y 2°', '3° y 4°', '5° y 6°'].map((tramo, i) => <div key={i} className="bg-white/10 border border-white/20 px-6 py-3 rounded-xl font-bold text-lg" data-id="element-84">
                {tramo}
              </div>)}
          </div>
        </div>
      </section>
    </>;
}